// emballage page produit 

function ajouterDivConteneur() {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    $('[data-section-type="product-template"] .grid-id-block-grid_open_1, [data-section-type="product-template"] .grid-id-block-grid_open_2').wrapAll('<div class="conteneur"></div>');
    $('.conteneur').wrapAll('<div class="conteneur-main-produit"></div>');
  }
}

$(document).ready(ajouterDivConteneur);  // Appeler la fonction au chargement de la page

//fin

//Code texte collection pour mobile
document.addEventListener('DOMContentLoaded', function() {
    var p = document.querySelector('.intro p');
  
    //if (p.textContent.length > 150) {
  if (p !== null && p.textContent.length > 150) {
      var readMoreBtn = document.createElement('button');
      readMoreBtn.classList.add('read-more-btn-mobile');
      readMoreBtn.textContent = 'Continuer à lire';
      p.parentNode.insertBefore(readMoreBtn, p.nextSibling);

      if (window.innerWidth <= 767) {
        readMoreBtn.style.display = 'block';
      }

      readMoreBtn.addEventListener('click', function() {
        p.style.height = 'auto';
        p.style.webkitMaskImage = 'none';
        p.style.maskImage = 'none';
        readMoreBtn.style.display = 'none';
      });

      window.addEventListener('resize', function() {
        if (window.innerWidth <= 767) {
          readMoreBtn.style.display = 'block';
        } else {
          readMoreBtn.style.display = 'none';
        }
      });
    }
  });

//FIn Code texte collection pour mobile

//ajout class images blog
$('.block-f1d5ed86-ce77-4221-9839-0fe912ffe20f img').addClass('centered');
//ajout conteneur images blog
$('.block-f1d5ed86-ce77-4221-9839-0fe912ffe20f img').wrap('<div class="image-container-blog"></div>');

//fin ajout class image blog

//guide des tailles 
/*
document.addEventListener('DOMContentLoaded', function() {
    const productTitle = document.querySelector('.product-title').innerText;

    if (productTitle.includes('bague')) {
        const table = document.createElement('table');
        table.className = 'size-guide-sizes-table';
        table.innerHTML = `
            <thead>
                <tr>
                    <th>Tailles U.S</th>
                    <th>Tailles Françaises</th>
                    <th>Tailles en millimètres</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>6</td>
                    <td>51-52</td>
                    <td>16.5</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>54-55</td>
                    <td>17.4</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>57-58</td>
                    <td>18.2</td>
                </tr>
                <!-- Ajouter plus de lignes ici -->
            </tbody>
        `;

        const guideButton = document.createElement('button');
        guideButton.className = 'size-guide-button';
        guideButton.innerText = 'Voir le guide des tailles';
        guideButton.addEventListener('click', function() {
            document.querySelector('.product-description').classList.toggle('show-table');
        });

        const swatchElement = document.querySelector('div.swatch.clearfix');
        swatchElement.parentNode.insertBefore(guideButton, swatchElement.nextSibling);
        swatchElement.parentNode.insertBefore(table, guideButton.nextSibling);
    }
});
*/


//test new readmore
document.addEventListener('DOMContentLoaded', function() {
    var div = document.querySelector('.grid-item.product-description.rte');
  
    if (div !== null && div.textContent.length > 150) {
        var readMoreBtn = document.createElement('button');
        readMoreBtn.classList.add('read-more-btn-pdescription');
        readMoreBtn.textContent = 'Afficher Plus';
        div.parentNode.insertBefore(readMoreBtn, div.nextSibling);
        readMoreBtn.style.display = 'block';

        readMoreBtn.addEventListener('click', function() {
            div.style.height = 'auto';
            div.style.webkitMaskImage = 'none';
            div.style.maskImage = 'none';
            readMoreBtn.style.display = 'none';
        });
    }
});



/*

//readmore-description-produits
window.addEventListener('DOMContentLoaded', function() {
  const descriptions = document.querySelectorAll('.grid-item.product-description.rte');

  descriptions.forEach(function(description) {
    const buttoncontainer = document.createElement('div');
    buttoncontainer.className = 'description-readmore-container';
    const button = document.createElement('span');
    button.textContent = 'Découvrir +';
    button.className = 'description-readmore';
     buttoncontainer.appendChild(button);
    description.appendChild(buttoncontainer);
    

    button.addEventListener('click', function() {
      description.classList.add('expanded');
       button.style.display = 'none';
       buttoncontainer.style.display = 'none';
    });

    if (description.scrollHeight > 250) {
      buttoncontainer.style.display = 'block';
    }
  });
});


// fin readmore-description
*/

//image avec data se charge au scroll 

function createPlaceholder(w, h) {
    var placeholder = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${w} ${h}'%3E%3C/svg%3E`;
    return placeholder;
}

document.addEventListener("DOMContentLoaded", function() {
  const images = document.querySelectorAll("img[data-src], source[data-srcset]");

  images.forEach(image => {
    var width = image.getAttribute('width') || 100;
    var height = image.getAttribute('height') || 100;
    if (image.tagName.toLowerCase() == 'img') {
      image.src = createPlaceholder(width, height);
    }
  });

  const config = {
    rootMargin: "0px 0px 500px 100px",
    threshold: 0
  };

  let observer;

  if ("IntersectionObserver" in window) {
    observer = new IntersectionObserver(onIntersection, config);
    images.forEach(image => {
      observer.observe(image);
    });
  } else {
    console.log("Intersection Observer not supported");
    Array.from(images).forEach(image => loadImage(image));
  }

  function onIntersection(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        observer.unobserve(entry.target);
        loadImage(entry.target);
      }
    });
  }

  function loadImage(image) {
    image.onload = function() {
        image.classList.add("loaded");
    };
    if (image.tagName.toLowerCase() == 'img') {
      image.src = image.dataset.src;
    } else if (image.tagName.toLowerCase() == 'source') {
      image.srcset = image.dataset.srcset;
    }
  }
});


//fin image avec data se charge au scroll 



$(".readmore-link").click( function(e) {
  // record if our text is expanded
  var isExpanded =  $(e.target).hasClass("expand");
  
  //close all open paragraphs
  $(".readmore.expand").removeClass("expand");
  $(".readmore-link.expand").removeClass("expand");
  
  // if target wasn't expand, then expand it
  if (!isExpanded){
    $( e.target ).parent( ".readmore" ).addClass( "expand" );
    $(e.target).addClass("expand");  
  } 
});

//debut supprimer balises vides

// Définir la fonction removeEmptyElements
function removeEmptyElements(elementType) {
  const container = document.querySelector('#tab-1.tab__content');
  const elements = container.getElementsByTagName(elementType);

  // Parcourir tous les éléments du type spécifié
  for (let i = elements.length - 1; i >= 0; i--) {
    const element = elements[i];

    // Vérifier si l'élément est vide
    if (element.textContent.trim() === '') {
      // Supprimer l'élément s'il est vide
      element.parentNode.removeChild(element);
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Liste de tous les types d'éléments que vous voulez vérifier
  const elementTypes = ['h1', 'h2', 'h3', 'h4', 'p', 'span', 'div'];

  // Appeler removeEmptyElements pour chaque type d'élément
  elementTypes.forEach(function(elementType) {
    removeEmptyElements(elementType);
  });
});


//fin supprimer balises vides

// nombres page accueil
/*(function() {
  function incrementNumber(node,nb) {

    let sectionNumbers = document.querySelector('.sectionNumbers');   
    let sectionCounter = 0;
    let numbers = document.querySelector("."+node);

    let n = nb;
    let cpt = 0; 
    let delay = 1000; 
    let delta = Math.ceil((delay * 15000) / n);

    function countdownNumbers() {
      numbers.innerHTML = ++cpt;
      if( cpt < n ) { 
        setTimeout(countdownNumbers, numbers);
      }
    }

    document.addEventListener('scroll', function() {
      sectionCounter++;        
      if(sectionCounter == 1) {
        setTimeout(countdownNumbers, numbers);
      }
    }), {passive:true};
  }
  setTimeout(function(){ 
    incrementNumber("number1", 100);
    incrementNumber("number2", 500);
    incrementNumber("number3", 14);
    incrementNumber("number4", 50);
    incrementNumber("number5", 7);
  }, 2000);
})(); */

//traduire

/*
$(document).ready(function(){
 $(".swatch .header").text(function () { 
 return $(this).text().replace("Color", "Couleur");
 });
 $(".swatch .header").text(function () { 
 return $(this).text().replace("Size", "Taille");
 });
   $("label").text(function () { 
 return $(this).text().replace("Blue", "Bleu");
 });
     $("label").text(function () { 
 return $(this).text().replace("Green", "Vert");
 });
     $("label").text(function () { 
 return $(this).text().replace("Red", "Rouge");
 });
     $("label").text(function () { 
 return $(this).text().replace("White", "Blanc");
 });
});
*/
